module.exports = __webpack_public_path__ + "static/media/nohistory.fb9bfb43.png";